import { TableCell } from "@mui/material";
import LookupChip from "./LookupChip";
import { CHIP_COLUMN_WIDTHS } from "../constants/chipColumnWidths";

export default function LookupChipCells({ item, colorMaps }) {
  const { horizonColors, statusColors, priorityColors } = colorMaps;

  return (
    <>
      <TableCell sx={CHIP_COLUMN_WIDTHS.horizon}>
        <LookupChip
          label={item.horizon}
          hex={horizonColors[item.horizon]}
          variant="outlined"
        />
      </TableCell>
      <TableCell sx={CHIP_COLUMN_WIDTHS.status}>
        <LookupChip label={item.status} hex={statusColors[item.status]} />
      </TableCell>
      <TableCell sx={CHIP_COLUMN_WIDTHS.priority}>
        <LookupChip
          label={item.priority}
          hex={priorityColors[item.priority]}
          variant="outlined"
        />
      </TableCell>
    </>
  );
}
